// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 100\"><defs><pattern id=\"grain\" width=\"100\" height=\"100\" patternUnits=\"userSpaceOnUse\"><circle cx=\"25\" cy=\"25\" r=\"1\" fill=\"white\" opacity=\"0.1\"/><circle cx=\"75\" cy=\"75\" r=\"1\" fill=\"white\" opacity=\"0.1\"/><circle cx=\"50\" cy=\"10\" r=\"0.5\" fill=\"white\" opacity=\"0.1\"/><circle cx=\"10\" cy=\"60\" r=\"0.5\" fill=\"white\" opacity=\"0.1\"/><circle cx=\"90\" cy=\"40\" r=\"0.5\" fill=\"white\" opacity=\"0.1\"/></pattern></defs><rect width=\"100\" height=\"100\" fill=\"url%28%23grain%29\"/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-page {
  background: var(--bg-primary);
  transition: background-color 0.3s ease;
}

.hero {
  padding: 4rem 2rem 2rem;
  text-align: center;
  background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
  color: white;
  position: relative;
  overflow: hidden;
  margin-bottom: 2rem;
}

.hero::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  opacity: 0.3;
}

.hero--promoted {
  padding: 0;
  background: var(--bg-secondary);
}

.hero--promoted::before {
  display: none;
}

.hero-promoted-link {
  display: block;
  max-width: 1200px;
  margin: 0 auto;
  text-decoration: none;
  transition: opacity 0.2s ease;
}

.hero-promoted-link:hover {
  opacity: 0.92;
}

.hero-promoted-image {
  display: block;
  width: 100%;
  height: auto;
  max-height: 420px;
  object-fit: cover;
  object-position: center;
}

.hero-content {
  position: relative;
  z-index: 1;
  max-width: 800px;
  margin: 0 auto;
}

.hero-title {
  font-size: 2.5rem;
  font-weight: 700;
  margin: 0 0 1rem 0;
  font-family: 'Inter', sans-serif;
  background: linear-gradient(135deg, #ffffff 0%, #e2e8f0 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.hero-subtitle {
  font-size: 1.1rem;
  color: #cbd5e1;
  margin: 0 0 1.5rem 0;
  line-height: 1.6;
  font-weight: 400;
}

.home-page .container {
  max-width: 1600px;
  margin: 0 auto;
  padding: 0 2rem;
}

.product-filter {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
}

.product-filter-btn {
  min-height: 44px;
  padding: 0.625rem 1.25rem;
  border: 1px solid var(--border-primary);
  border-radius: 999px;
  background: var(--bg-secondary);
  color: var(--text-secondary);
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.product-filter-btn:hover:not(.active) {
  border-color: var(--accent-primary);
  color: var(--text-primary);
}

.product-filter-btn:focus-visible {
  outline: 2px solid var(--accent-primary);
  outline-offset: 2px;
}

.product-filter-btn.active {
  background: var(--accent-primary);
  border-color: var(--accent-primary);
  color: #fff;
  box-shadow: 0 4px 12px var(--shadow-primary);
}

.product-filter-empty {
  text-align: center;
  color: var(--text-secondary);
  padding: 2rem 1rem 3rem;
  margin: 0;
}

.watchfaces-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1.5rem;
  padding: 1rem 0 3rem;
}

.watchface-card {
  background: var(--bg-primary);
  border: 1px solid var(--border-primary);
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 2px 8px var(--shadow-primary);
  transition: all 0.3s ease;
  cursor: pointer;
}

.watchface-card:hover {
  border-color: var(--accent-primary);
  box-shadow: 0 8px 24px var(--shadow-primary);
  transform: translateY(-4px);
}

.watchface-link {
  text-decoration: none;
  color: inherit;
  display: block;
}

.watchface-image-container {
  position: relative;
  width: 100%;
  padding-top: 100%;
  overflow: hidden;
  background: var(--bg-secondary);
}

.watchface-new-badge {
  position: absolute;
  top: 3px;
  right: -25px;
  width: 90px;
  padding: 3px 0;
  background: #e6b800;
  transform: rotate(45deg);
  text-align: center;
  pointer-events: none;
  z-index: 2;
  border-top: 2px solid #1a1a1a;
  border-bottom: 2px solid #1a1a1a;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.35);
}

.watchface-new-badge span {
  color: #1a1a1a;
  font-size: 0.8rem;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  white-space: nowrap;
}

.watchface-card--new {
  animation: watchface-card-new-highlight 1.6s ease-out 0.9s forwards;
}

@keyframes watchface-card-new-highlight {
  0% {
    box-shadow: 0 0 0 0 rgba(250, 204, 21, 0.0);
  }
  20% {
    box-shadow: 0 0 0 6px rgba(250, 204, 21, 0.45);
  }
  60% {
    box-shadow: 0 0 0 10px rgba(250, 204, 21, 0.0);
  }
  100% {
    box-shadow: 0 2px 8px var(--shadow-primary);
  }
}

.watchface-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.watchface-card:hover .watchface-image {
  transform: scale(1.05);
}

.watchface-info {
  padding: 0.75rem 1rem;
  background: var(--bg-primary);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.4rem;
}

.watchface-name {
  font-size: 1.25rem;
  font-weight: 700;
  margin: 0;
  color: var(--text-primary);
  text-align: center;
  line-height: 1.3;
}

.watchface-version-badge {
  display: inline-block;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  padding: 0.2rem 0.55rem;
  border-radius: 999px;
  border: 1px solid transparent;
  line-height: 1.2;
}

/* VX + Elite: beide Kaufwege verfügbar */
.version-badge-combo {
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.15), rgba(234, 179, 8, 0.18));
  color: var(--text-primary);
  border-color: rgba(59, 130, 246, 0.4);
}

/* Nur Elite (Garmin Pay) */
.version-badge-elite {
  background: rgba(234, 179, 8, 0.16);
  color: #a16207;
  border-color: rgba(234, 179, 8, 0.5);
}

.version-badge-vx {
  background: rgba(59, 130, 246, 0.14);
  color: #1d4ed8;
  border-color: rgba(59, 130, 246, 0.45);
}

.version-badge-beta {
  background: rgba(107, 114, 128, 0.16);
  color: var(--text-secondary);
  border-color: rgba(107, 114, 128, 0.4);
}

.dark .version-badge-elite { color: #fbbf24; }
.dark .version-badge-vx { color: #93c5fd; }

/* Loading/Error */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 50vh;
  gap: 1rem;
}

.loading-spinner {
  width: 50px;
  height: 50px;
  border: 4px solid var(--border-primary);
  border-top: 4px solid var(--accent-primary);
  border-radius: 50%;
}

.loading-container p {
  color: var(--text-secondary);
}

.error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 50vh;
  gap: 1rem;
  text-align: center;
  padding: 2rem;
}

.error-container h2 {
  color: var(--accent-primary);
  margin: 0;
}

.error-container p {
  color: var(--text-secondary);
  margin: 0;
}

.error-container button {
  background: var(--accent-primary);
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.error-container button:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}

@media (max-width: 767px) {
  .hero {
    padding: 3rem 1rem 1.5rem;
  }

  .hero--promoted {
    padding: 0;
  }

  .hero-promoted-image {
    max-height: 220px;
  }

  .hero-title {
    font-size: 2rem;
  }

  .hero-subtitle {
    font-size: 1rem;
  }

  .home-page .container {
    padding: 0 1rem;
  }

  .watchfaces-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 0.75rem;
  }

  .watchface-card {
    border-radius: 10px;
  }

  .watchface-info {
    padding: 0.5rem;
  }

  .watchface-name {
    font-size: 0.95rem;
  }

  .watchface-new-badge {
    top: 3px;
    right: -25px;
    width: 90px;
    padding: 3px 0;
  }

  .watchface-new-badge span {
    font-size: 0.55rem;
  }
}

@media (max-width: 400px) {
  .watchfaces-grid {
    gap: 0.5rem;
  }

  .watchface-info {
    padding: 0.4rem;
  }

  .watchface-name {
    font-size: 0.8rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/HomePage.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,sCAAsC;AACxC;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,mDAAyiB;EACziB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,uCAAuC;EACvC,oBAAoB;EACpB,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;EACnC,WAAW;EACX,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,uCAAuC;EACvC,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;EAC3C,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;EAClB,oBAAoB;EACpB,UAAU;EACV,6BAA6B;EAC7B,gCAAgC;EAChC,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mEAAmE;AACrE;;AAEA;EACE;IACE,2CAA2C;EAC7C;EACA;IACE,8CAA8C;EAChD;EACA;IACE,8CAA8C;EAChD;EACA;IACE,2CAA2C;EAC7C;AACF;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,oBAAoB;EACpB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA,yCAAyC;AACzC;EACE,sFAAsF;EACtF,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA,2BAA2B;AAC3B;EACE,mCAAmC;EACnC,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;EACrC,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA,6BAA6B,cAAc,EAAE;AAC7C,0BAA0B,cAAc,EAAE;;AAE1C,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,4BAA4B;EAC5B,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,SAAS;AACX;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,qCAAqC;IACrC,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".home-page {\n  background: var(--bg-primary);\n  transition: background-color 0.3s ease;\n}\n\n.hero {\n  padding: 4rem 2rem 2rem;\n  text-align: center;\n  background: linear-gradient(135deg, #1e293b 0%, #334155 100%);\n  color: white;\n  position: relative;\n  overflow: hidden;\n  margin-bottom: 2rem;\n}\n\n.hero::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 100\"><defs><pattern id=\"grain\" width=\"100\" height=\"100\" patternUnits=\"userSpaceOnUse\"><circle cx=\"25\" cy=\"25\" r=\"1\" fill=\"white\" opacity=\"0.1\"/><circle cx=\"75\" cy=\"75\" r=\"1\" fill=\"white\" opacity=\"0.1\"/><circle cx=\"50\" cy=\"10\" r=\"0.5\" fill=\"white\" opacity=\"0.1\"/><circle cx=\"10\" cy=\"60\" r=\"0.5\" fill=\"white\" opacity=\"0.1\"/><circle cx=\"90\" cy=\"40\" r=\"0.5\" fill=\"white\" opacity=\"0.1\"/></pattern></defs><rect width=\"100\" height=\"100\" fill=\"url(%23grain)\"/></svg>');\n  opacity: 0.3;\n}\n\n.hero--promoted {\n  padding: 0;\n  background: var(--bg-secondary);\n}\n\n.hero--promoted::before {\n  display: none;\n}\n\n.hero-promoted-link {\n  display: block;\n  max-width: 1200px;\n  margin: 0 auto;\n  text-decoration: none;\n  transition: opacity 0.2s ease;\n}\n\n.hero-promoted-link:hover {\n  opacity: 0.92;\n}\n\n.hero-promoted-image {\n  display: block;\n  width: 100%;\n  height: auto;\n  max-height: 420px;\n  object-fit: cover;\n  object-position: center;\n}\n\n.hero-content {\n  position: relative;\n  z-index: 1;\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.hero-title {\n  font-size: 2.5rem;\n  font-weight: 700;\n  margin: 0 0 1rem 0;\n  font-family: 'Inter', sans-serif;\n  background: linear-gradient(135deg, #ffffff 0%, #e2e8f0 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.hero-subtitle {\n  font-size: 1.1rem;\n  color: #cbd5e1;\n  margin: 0 0 1.5rem 0;\n  line-height: 1.6;\n  font-weight: 400;\n}\n\n.home-page .container {\n  max-width: 1600px;\n  margin: 0 auto;\n  padding: 0 2rem;\n}\n\n.product-filter {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 0.5rem;\n  margin-bottom: 1.5rem;\n}\n\n.product-filter-btn {\n  min-height: 44px;\n  padding: 0.625rem 1.25rem;\n  border: 1px solid var(--border-primary);\n  border-radius: 999px;\n  background: var(--bg-secondary);\n  color: var(--text-secondary);\n  font-size: 0.95rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.product-filter-btn:hover:not(.active) {\n  border-color: var(--accent-primary);\n  color: var(--text-primary);\n}\n\n.product-filter-btn:focus-visible {\n  outline: 2px solid var(--accent-primary);\n  outline-offset: 2px;\n}\n\n.product-filter-btn.active {\n  background: var(--accent-primary);\n  border-color: var(--accent-primary);\n  color: #fff;\n  box-shadow: 0 4px 12px var(--shadow-primary);\n}\n\n.product-filter-empty {\n  text-align: center;\n  color: var(--text-secondary);\n  padding: 2rem 1rem 3rem;\n  margin: 0;\n}\n\n.watchfaces-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 1.5rem;\n  padding: 1rem 0 3rem;\n}\n\n.watchface-card {\n  background: var(--bg-primary);\n  border: 1px solid var(--border-primary);\n  border-radius: 14px;\n  overflow: hidden;\n  box-shadow: 0 2px 8px var(--shadow-primary);\n  transition: all 0.3s ease;\n  cursor: pointer;\n}\n\n.watchface-card:hover {\n  border-color: var(--accent-primary);\n  box-shadow: 0 8px 24px var(--shadow-primary);\n  transform: translateY(-4px);\n}\n\n.watchface-link {\n  text-decoration: none;\n  color: inherit;\n  display: block;\n}\n\n.watchface-image-container {\n  position: relative;\n  width: 100%;\n  padding-top: 100%;\n  overflow: hidden;\n  background: var(--bg-secondary);\n}\n\n.watchface-new-badge {\n  position: absolute;\n  top: 3px;\n  right: -25px;\n  width: 90px;\n  padding: 3px 0;\n  background: #e6b800;\n  transform: rotate(45deg);\n  text-align: center;\n  pointer-events: none;\n  z-index: 2;\n  border-top: 2px solid #1a1a1a;\n  border-bottom: 2px solid #1a1a1a;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.35);\n}\n\n.watchface-new-badge span {\n  color: #1a1a1a;\n  font-size: 0.8rem;\n  font-weight: 800;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.watchface-card--new {\n  animation: watchface-card-new-highlight 1.6s ease-out 0.9s forwards;\n}\n\n@keyframes watchface-card-new-highlight {\n  0% {\n    box-shadow: 0 0 0 0 rgba(250, 204, 21, 0.0);\n  }\n  20% {\n    box-shadow: 0 0 0 6px rgba(250, 204, 21, 0.45);\n  }\n  60% {\n    box-shadow: 0 0 0 10px rgba(250, 204, 21, 0.0);\n  }\n  100% {\n    box-shadow: 0 2px 8px var(--shadow-primary);\n  }\n}\n\n.watchface-image {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.3s ease;\n}\n\n.watchface-card:hover .watchface-image {\n  transform: scale(1.05);\n}\n\n.watchface-info {\n  padding: 0.75rem 1rem;\n  background: var(--bg-primary);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.4rem;\n}\n\n.watchface-name {\n  font-size: 1.25rem;\n  font-weight: 700;\n  margin: 0;\n  color: var(--text-primary);\n  text-align: center;\n  line-height: 1.3;\n}\n\n.watchface-version-badge {\n  display: inline-block;\n  font-size: 0.7rem;\n  font-weight: 700;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n  padding: 0.2rem 0.55rem;\n  border-radius: 999px;\n  border: 1px solid transparent;\n  line-height: 1.2;\n}\n\n/* VX + Elite: beide Kaufwege verfügbar */\n.version-badge-combo {\n  background: linear-gradient(135deg, rgba(59, 130, 246, 0.15), rgba(234, 179, 8, 0.18));\n  color: var(--text-primary);\n  border-color: rgba(59, 130, 246, 0.4);\n}\n\n/* Nur Elite (Garmin Pay) */\n.version-badge-elite {\n  background: rgba(234, 179, 8, 0.16);\n  color: #a16207;\n  border-color: rgba(234, 179, 8, 0.5);\n}\n\n.version-badge-vx {\n  background: rgba(59, 130, 246, 0.14);\n  color: #1d4ed8;\n  border-color: rgba(59, 130, 246, 0.45);\n}\n\n.version-badge-beta {\n  background: rgba(107, 114, 128, 0.16);\n  color: var(--text-secondary);\n  border-color: rgba(107, 114, 128, 0.4);\n}\n\n.dark .version-badge-elite { color: #fbbf24; }\n.dark .version-badge-vx { color: #93c5fd; }\n\n/* Loading/Error */\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 50vh;\n  gap: 1rem;\n}\n\n.loading-spinner {\n  width: 50px;\n  height: 50px;\n  border: 4px solid var(--border-primary);\n  border-top: 4px solid var(--accent-primary);\n  border-radius: 50%;\n}\n\n.loading-container p {\n  color: var(--text-secondary);\n}\n\n.error-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 50vh;\n  gap: 1rem;\n  text-align: center;\n  padding: 2rem;\n}\n\n.error-container h2 {\n  color: var(--accent-primary);\n  margin: 0;\n}\n\n.error-container p {\n  color: var(--text-secondary);\n  margin: 0;\n}\n\n.error-container button {\n  background: var(--accent-primary);\n  color: white;\n  border: none;\n  padding: 0.75rem 1.5rem;\n  border-radius: 8px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.error-container button:hover {\n  opacity: 0.9;\n  transform: translateY(-1px);\n}\n\n@media (max-width: 767px) {\n  .hero {\n    padding: 3rem 1rem 1.5rem;\n  }\n\n  .hero--promoted {\n    padding: 0;\n  }\n\n  .hero-promoted-image {\n    max-height: 220px;\n  }\n\n  .hero-title {\n    font-size: 2rem;\n  }\n\n  .hero-subtitle {\n    font-size: 1rem;\n  }\n\n  .home-page .container {\n    padding: 0 1rem;\n  }\n\n  .watchfaces-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 0.75rem;\n  }\n\n  .watchface-card {\n    border-radius: 10px;\n  }\n\n  .watchface-info {\n    padding: 0.5rem;\n  }\n\n  .watchface-name {\n    font-size: 0.95rem;\n  }\n\n  .watchface-new-badge {\n    top: 3px;\n    right: -25px;\n    width: 90px;\n    padding: 3px 0;\n  }\n\n  .watchface-new-badge span {\n    font-size: 0.55rem;\n  }\n}\n\n@media (max-width: 400px) {\n  .watchfaces-grid {\n    gap: 0.5rem;\n  }\n\n  .watchface-info {\n    padding: 0.4rem;\n  }\n\n  .watchface-name {\n    font-size: 0.8rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
